import { Pipe, PipeTransform } from '@angular/core';
import { FilterableTraceSource, Trace, isInboundTraceSource } from '../models/tracer.model';

@Pipe({
  name: 'getTracesBySourceAndProviders',
})
export class GetTracesBySourceAndProvidersPipe implements PipeTransform {
  transform(traces: Trace[], source: FilterableTraceSource, providers: string): Trace[] {
    const matches = (s: string) => (source === 'json-api' ? isInboundTraceSource(s) : s === source);
    return traces?.filter(item => providers === item.providers && matches(item.source));
  }
}
